import { NavigateFunction } from "react-router-dom";

import { ApiService, CaseAdmin } from "pwapi";

import { CaseAdminDetail } from "../../reducers/admin/adminCaseReducer";
import { AsyncSagaAction, createAsyncSaga } from "../../utils/asyncActions";
import {
  ADMIN_CASE_REQUEST,
  ADMIN_UPDATE_CASE_REQUEST,
  ADMIN_DELETE_CASE_REQUEST,
  ADMIN_RESET_ERROR_MESSAGE,
  ADMIN_RESET_DELETION_STATUS,
  ADMIN_CREATE_QAREVIEW_REQUEST,
  ADMIN_UPDATE_QAREVIEW_REQUEST,
  ADMIN_UPDATE_INTEGRATIONS_REQUEST,
  ADMIN_REASSIGN_ACCESSION_NUMBER_REQUEST,
  ADMIN_REASSIGN_ACCESSION_NUMBER_SUCCESS,
  ADMIN_REASSIGN_ACCESSION_NUMBER_FAILURE,
  ADMIN_CASE_FAILURE,
  ADMIN_CASE_SUCCESS,
} from "../adminConstants";

export interface CaseAdminRelationships {
  active_assignment_id?: number;
  ordering_doctor_id?: number;
  lab_id?: number;
  accessioning_lab_id?: number;
  patient_id?: number;
}

export const requestAdminCase = createAsyncSaga(
  ADMIN_CASE_REQUEST,
  ADMIN_CASE_SUCCESS,
  ADMIN_CASE_FAILURE,
  (id) => `admin/cases/${id}`,
  (id) => ApiService.retrieveAdminCase({ id })
) as AsyncSagaAction<number>;

export const saveAdminCase = (
  payload: Partial<CaseAdmin & CaseAdminRelationships>
) => {
  return {
    type: ADMIN_UPDATE_CASE_REQUEST,
    payload,
  };
};

export const deleteAdminCase = (payload: {
  adminCase: CaseAdminDetail;
  navigate: NavigateFunction;
  historyState?: { label: string; prevUrl: string };
}) => {
  return {
    type: ADMIN_DELETE_CASE_REQUEST,
    payload,
  };
};

export const resetCaseErrorMessage = () => {
  return {
    type: ADMIN_RESET_ERROR_MESSAGE,
  };
};

export const resetDeletionStatus = () => {
  return {
    type: ADMIN_RESET_DELETION_STATUS,
  };
};

export const createQAReview = (values: {
  reviewed: boolean;
  note: string;
  caseId: number;
}) => {
  return {
    type: ADMIN_CREATE_QAREVIEW_REQUEST,
    payload: values,
  };
};

export const updateQAReview = ({ id, note }: { id: number; note: string }) => {
  return {
    type: ADMIN_UPDATE_QAREVIEW_REQUEST,
    payload: { id, requestBody: { note } },
  };
};

export const updateIntegrations = (payload: {
  caseId: number;
  patientId: number;
  external_order_id?: string | null;
  external_ezderm_order_id?: string | null;
  external_patient_id?: string | number | null;
  orderingDoctorId?: number;
  clinicId: number;
}) => {
  return {
    type: ADMIN_UPDATE_INTEGRATIONS_REQUEST,
    payload: {
      clinic_id: payload.clinicId,
      ordering_doctor_id: payload.orderingDoctorId,
      case_id: payload.caseId,
      external_order_id: payload.external_order_id,
      external_ezderm_order_id: payload.external_ezderm_order_id,
      external_patient_id: payload.external_patient_id,
      patient_id: payload.patientId,
    },
  };
};

type ReassignAccessionArgs = Parameters<
  typeof ApiService.reassignAccessionNumberAdminCase
>[0];
export const reassignAccessionNumberAdminCase = createAsyncSaga(
  ADMIN_REASSIGN_ACCESSION_NUMBER_REQUEST,
  ADMIN_REASSIGN_ACCESSION_NUMBER_SUCCESS,
  ADMIN_REASSIGN_ACCESSION_NUMBER_FAILURE,
  ({ id }) => `/api/admin/cases/${id}/reassign_accession_number/`,
  ApiService.reassignAccessionNumberAdminCase
) as AsyncSagaAction<ReassignAccessionArgs>;
